export const LinkData = [
  {
    id: 1,
    title: "Home",
    url: "/",
  },
  {
    id: 5,
    title: "Study materials",
    url: "/practice",
  },
  {
    id: 6,
    title: "Tuition",
    url: "/tuition",
  },
  {
    id: 7,
    title: "MCQ Tests",
    url: "/mcq",
  },
]
